import { AddButton } from '@/common/buttons/AddButton';
import { ApprButton } from '@/common/buttons/ApprButton';
import { ValButton } from '@/common/buttons/ValButton';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { GridConstants } from '@/common/grid/GridConstants';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback, useMemo, useState } from 'react';

export const CtrtList = ({ ownerCustId }) => {

  const [selectedEntities, setSelectedEntities] = useState([]);

  const selectedEntityIds = useMemo(() => {
    return selectedEntities.map(selectedEntity => selectedEntity.id);
  }, [selectedEntities])

  const isDisabled = useMemo(() => {
    return selectedEntities.some(entity => entity.status === 'IMPL');
  }, [selectedEntities]);

  const augNavEntityObj = (navEntityObj) => {
    navEntityObj.amendmentNum = 1;
  }

  const handleSelectionChanged = (event) => {
    const gridApi = event.api;
    const selectedNodeData = gridApi.getSelectedNodes().map(node => node.data);
    setSelectedEntities(selectedNodeData);
  }

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('status', ['IMPL', 'DRAFT', 'APPROVING']));

    // If in the Customer detail
    if (!ownerCustId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('ownerCustId', ownerCustId));
  }, [ownerCustId]);

  const augButtons = (buttons) => {
    buttons.pop() //remove original add button
    buttons.push(
      <AddButton key="addButton" augNavEntityObj={augNavEntityObj} />,
      <ValButton key="valButton" selectedEntityIds={selectedEntityIds} disabled={isDisabled} />,
      <ApprButton key="apprButton" selectedEntities={selectedEntities} />
    )
  };

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.checkbox = GridConstants.checkbox;
  };

  return (
    <EntityList entity="CTRT"
      augRowsReq={augRowsReq}
      augButtons={augButtons}
      augFieldDefs={augFieldDefs} 
      gridOptions={{
        rowSelection: 'multiple'
      }}
      events={{
        onSelectionChanged: handleSelectionChanged
      }}
    />
  )
}
